// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"147a89ca","487":"475b4c5b","783":"e4b8fa2a"}[chunkId] + ".css";
};